import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { TicketStatusFormattedValues } from "interfaces/entities/ticket";

import { IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: string[];
  onChange(filterUpdate: IFilterUpdate<string[] | null>): void;
}

const items = Object.entries(TicketStatusFormattedValues).map(([value, label]) => ({
  key: value,
  name: label,
}));

const TicketStatusFilter: FC<IProps> = props => {
  const { onChange, filterValues } = props;

  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    const isEmpty = !selectedItem || selectedItem.length === 0;

    onChange({
      name: Filter.TicketStatus,
      value: isEmpty ? null : (selectedItem?.map(item => item.key) ?? []),
    });
  };

  const selectedStatuses = items
    .filter(agent => filterValues?.includes(agent.key))
    .map(status => ({ key: status.key, name: status.name }));

  return (
    <Picker
      id="ticket-status-filter"
      type="multi"
      hideClearButton
      openedOnInit
      options={items}
      onSelect={handleChange}
      selected={selectedStatuses}
      placeholder="Select"
      searchDisabled
    />
  );
};

export default withFilterBase(TicketStatusFilter);
